export class Synchronization {
  itemType!: string;
  itemsCount!: number;
  itemsUpdated!: number;
  itemsRemoved!: number;
  lastExecution!: string;

  constructor(dto?: Partial<Synchronization>) {
    Object.assign(this, dto);
  }
}
